import clsx from 'clsx'

import { useBooleanState } from '@/shared/lib/hooks/useBooleanState'
import { FaqSection } from '@/shared/ui/FaqSection'

import cl from './style.module.scss'

export interface ServiceFaqProps {
	faqItems: { question: string; answer: string }[]
}

export const ServiceFaq = (props: ServiceFaqProps) => {
	const { faqItems } = props
	const { active, disable, enable } = useBooleanState()
	return (
		<section className={cl.faq}>
			<div className={cl.wrapper}>
				<div className={cl.action}>
					<h2 className={cl.title}>Частые вопросы</h2>
					<button className={cl.btn} onClick={active ? disable : enable}>
						{active ? 'Скрыть' : 'Смотреть'}
					</button>
				</div>

				<div className={clsx(cl.content, { [cl.content_hidden]: !active })}>
					<FaqSection items={faqItems} />
				</div>
			</div>
		</section>
	)
}
